export default {
    logo: null,
}